import React from 'react';
import { useSelector } from 'react-redux';
import { expensePaymentSource } from '../apis/parameter';
import dictionary from '../constants/dictionary';
import SelectSync from './SelectSync';
import { formatNumber } from 'accounting';

const HIDDEN_SOURCES = new Set([
    "FINANSBANK GUNLUK VADELI TL",
    "FINANSBANK SISLI EUR FON",
    "FINANSBANK SISLI USD FON",
    "GARANTI BANKASI - EUR0",
    "GARANTI BANKASI - GBP",
    "GARANTI BANKASI - TL",
    "GARANTI BANKASI - USD",
    "GARANTI BANKASI - BARBAROS SUBESI TL",
    "AKBANK - KAYISDAGI SUBESI TL",
    "NAKIT TL",
    "QNB ENPARA USD - VADELI-1",
    "QNB ENPARA USD - VADELI-2",
    "QNB ENPARA USD - VADELI-3",
    "QNB FINANSBANK KUR KORUMALI MEVDUAT HESABI (EUR)",
    "ZIRAAT BANKASI EUR",
    "ZIRAAT BANKASI USD",
    "ZIRAAT BANKASI TL VADELI-2 HESAP",
    "ZIRAAT BANKASI VADELI TL",
    "ZIRAAT BANKASI VADELI TL 2",
    "ZIRAAT BANKASI VADESIZ TL (KREDI HS)"
]);

const normalizeText = text =>
    (text || "")
        .toLocaleUpperCase("tr-TR")
        .replace(/İ/g, "I")
        .replace(/Ş/g, "S")
        .replace(/Ğ/g, "G")
        .replace(/Ü/g, "U")
        .replace(/Ö/g, "O")
        .replace(/Ç/g, "C")
        .replace(/\s+/g, " ")
        .trim();

const isHiddenSource = item => HIDDEN_SOURCES.has(normalizeText(item && item.label));

const isCreditCard = item => (item && item.intHelper3 === 1);

const mapPaymentLabels = item => {
    if (!isCreditCard(item))
        return item;

    const cardLimit = item.decimalHelper2 || 0;
    const remainingLimit = item.decimalHelper || 0;
    return {
        ...item,
        label: `${item.label} (Kart Limit: ${formatNumber(cardLimit, 2)} | Kalan Bakiye: ${formatNumber(remainingLimit, 2)})`
    };
};

const ExPaySourceSelect = props => {

    const options = (useSelector(state => state.main.expensePaymentSource) || []).filter(item => !isHiddenSource(item));
    let filtered = [];
    
    if (props.screen === 'exchange') {
        filtered = props.type === 'tl' ? options.filter(item => item.stringHelper2 === 'TL') : options.filter(item => item.stringHelper2 !== 'TL');
        if (props.bank) {
            filtered = filtered.filter(item => item.stringHelper3 === props.bank);
        }
    }

    const nonCardOptions = options.filter(item => !isCreditCard(item));
    const cardOptions = options.filter(item => isCreditCard(item));
    const allowCards = props.screen === 'payment' || props.screen === 'expense-payment' || props.screen === 'bank-activity';
    const sourceOptions = props.onlyCards
        ? cardOptions
        : (props.type ? filtered : (allowCards ? options : nonCardOptions));
    const finalOptions = allowCards ? sourceOptions.map(mapPaymentLabels) : sourceOptions;

    return (
        <SelectSync
            className={props.className}
            changeFn={props.setValue}
            optionsFn={expensePaymentSource}
            value={props.value}
            placeholder={dictionary.BANK_ACCOUNT}
            options={finalOptions}
        />
    )
}

export default ExPaySourceSelect;